import { Component, Input, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SETTINGS } from '../../../../core/config/common.settings';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AgentService } from '../../../../core/services/agent.service';
import { ContactService } from '../../../../core/services/contact.service';
import { LoadingService } from '../../../../core/services/loading.service';
import { ActionAlert } from '../../../../core/dto/actionAlert';
import { CountryService } from '../../../../core/services/country.service';
import { AppUtils } from '../../../../core/config/app.utils';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-add-edit-contact',
  templateUrl: './add-edit-contact.component.html',
  styleUrls: ['./add-edit-contact.component.scss'],
})
export class AddEditContactComponent implements OnInit {
  @Input() contactData?: any;
  @Input() agent?: any;
  @Input() mode?: any;
  contactForm: any;
  formErrors: any = {
    name: '',
    email: '',
    contactNo: '',
    dialCode: '',
  };
  countries: any[] = [];
  isSubmitting: boolean = false;

  constructor(
    private fb: FormBuilder,
    private modal: NzModalRef,
    private message: NzMessageService,
    private contactService: ContactService,
    private agentService: AgentService,
    private loading: LoadingService,
    private countryService: CountryService,
    private translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
    this.getCountries();
    this.contactForm = this.fb.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.email]],
      contactNo: ['', [Validators.pattern(SETTINGS.REGEX.PHONE.EXP)]],
      dialCode: ['']
    });

    if (this.mode === 'edit') {
      this.contactForm.patchValue(this.contactData);
    }
    this.contactForm.valueChanges.subscribe((form: any) => {
      console.log(form);
      AppUtils.getFormErrors(this.contactForm, this.formErrors);
    });
  }

  async getCountries(): Promise<void> {
    this.countries = await this.countryService.getCountries();
  }

  async addNewContact(): Promise<any> {
    this.isSubmitting = true;
    this.loading.start();
    try {
      const payload = this.contactForm.getRawValue();
      await this.contactService.createContact({
        ...payload,
        agent: this.agent._id,
      });
      this.modal.close('success');
      this.loading.stop();
      this.isSubmitting = false;
    } catch (e: any) {
      this.message.error(
        this.translocoService.translate('agents.addEdit.messages.genericError')
      );
      this.modal.close('not');
      this.loading.stop();
      this.isSubmitting = false;
    }
  }

  async editContact(): Promise<void> {
    this.isSubmitting = true;
    this.loading.start();
    try {
      const payload = this.contactForm.getRawValue();
      await this.contactService.updateContact({
        ...payload,
        _id: this.contactData._id,
      });
      this.modal.close('success');
      this.loading.stop();
      this.isSubmitting = false;
    } catch (e: any) {
      this.message.error(
        this.translocoService.translate('agents.addEdit.messages.genericError')
      );
      this.modal.close('not');
      this.loading.stop();
      this.isSubmitting = false;
    }
  }
}
